import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Al cambiar de ruta sube al inicio; si la URL trae hash (#ofertas, #faq...)
 * desplaza hasta esa sección (funciona también al llegar desde otra página,
 * esperando a que el contenido se renderice).
 */
const scrollToHash = (hash) => {
    const id = decodeURIComponent(hash.replace('#', ''));
    if (!id) return false;
    const el = document.getElementById(id);
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
};

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
            return undefined;
        }
        if (scrollToHash(hash)) return undefined;
        // El destino puede no existir aún (página cargando): reintenta brevemente
        let tries = 0;
        const t = setInterval(() => {
            tries += 1;
            if (scrollToHash(hash) || tries > 20) clearInterval(t);
        }, 100);
        return () => clearInterval(t);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
